import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors} from '@angular/forms';

@Directive({
  selector: '[appFunctionValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: FunctionValidatorDirective, multi: true}]
})
export class FunctionValidatorDirective {

  @Input('appFunctionValidator') fn: (a: any) => boolean;

  constructor() { }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.fn(control.value) ? null : { 'failed-function-validation': true };
  }

}
